import fetch from '../utils/fetch'                            //暂时不用fetch去获取请求数据，在httpSrv中干这个事情
import {getStore} from '../utils/mUtils'
// import {get, post,deletes,put} from '../utils/httpSrv.js' ;//导入axios实例文件中方法

/**
 * 获取用户信息
 */

export const getUser = () => fetch('/v1/user', {user_id: getStore('user_id')});


/**
 * 账号密码登录
 */
export const accountLogin = (username, password, captcha_code) => fetch('/v2/custuser/login', {username, password, captcha_code}, 'POST');


/**
 * 退出登录
 */
export const signout = () => fetch('/v2/signout');



// WEBPACK FOOTER //
// ./src/service/getData.js